import React from 'react';
import { Affix, Button, Flex, Form } from 'antd';

/**
 * A component to display the Create Patterns button with cost estimation
 */
const CreatePatternsButton = React.memo(({ 
    selectedPatternIds, 
    projectionCostDetails, 
    isFormSubmitting, 
    isEstimatingCost, 
    isSaving, 
    isAssignmentTooBigForProjection,
    handleContinueLater,
}) => {
    // Determine the button text based on selection state
    const buttonText = selectedPatternIds.length > 0 
        ? `Create selected patterns ${projectionCostDetails}` 
        : `Create patterns ${projectionCostDetails}`;

    // Determine if the button should be disabled
    const isButtonDisabled = isAssignmentTooBigForProjection || 
        (selectedPatternIds.length === 0 && projectionCostDetails !== '');

    return (
        <Form.Item>
            <Affix offsetBottom={32}>
                <Flex justify='end' gap={8}>
                    <Button onClick={handleContinueLater} size='large'>Continue Later</Button>
                    <Button
                        type='primary'
                        htmlType='submit'
                        size='large'
                        loading={isFormSubmitting || isEstimatingCost || isSaving}
                        disabled={isButtonDisabled}
                    >
                        {buttonText}
                    </Button>
                </Flex>
            </Affix>
        </Form.Item>
    );
});

export default CreatePatternsButton; 